<template>
  <b-container fluid>
    <b-form @submit.prevent="submit">
      <b-row class="mb-3">
        <b-col cols="9">
          <h1 class="font-weight-bold text-primary">Complete Repair Ticket</h1>
        </b-col>
        <b-col cols="3">
          <b-button v-if="!repair.cancelled_at && !repair.repair_complete" :variant="!cancelRepairClicked ? 'danger' : 'dark'" class="ml-2 float-right" @click="cancelRepair">{{ cancelRepairClicked ? 'Are you sure?' : 'Cancel' }}</b-button>
          <b-button v-if="repair.cancelled_at && !repair.repair_complete" variant="outline-danger" class="ml-2 float-right">Cancelled</b-button>
        </b-col>
      </b-row>
      <b-row v-if="isLoading">
        <b-col cols="12">
          <p class="text-center"><b-spinner variant="secondary"></b-spinner></p>
        </b-col>
      </b-row>
      <b-row v-if="!isLoading">
        <b-col cols="12">
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Name" :invalid-feedback="validationInvalidFeedback(errors, 'name')">
                <b-form-input :disabled="true" :state="validationState(errors, 'name')" v-model="repair.ticket.name" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Email" :invalid-feedback="validationInvalidFeedback(errors, 'email')">
                <b-form-input :disabled="true" :state="validationState(errors, 'email')" v-model="repair.ticket.email" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="Phone" :invalid-feedback="validationInvalidFeedback(errors, 'phone')">
                <b-form-input :disabled="true" :state="validationState(errors, 'phone')" v-model="repair.ticket.phone" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="SPA Serial Number" :invalid-feedback="validationInvalidFeedback(errors, 'spa')">
                <b-form-input :disabled="true" :state="validationState(errors, 'spa')" v-model="repair.ticket.spa" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Status" :invalid-feedback="validationInvalidFeedback(errors, 'status')">
                <b-form-input :disabled="true" :state="validationState(errors, 'spa')" :value="status" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label="Description of the Fault" :invalid-feedback="validationInvalidFeedback(errors, 'description')">
                <b-form-textarea :disabled="true" :state="validationState(errors, 'description')" v-model="repair.ticket.description" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col class="d-flex flex-row" cols="12" md="9" @click.prevent="toggleCollapse('address')" role="button">
                    <b-icon class="align-self-center cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['address'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                    <div class="d-flex flex-column flex-fill ml-4">
                      <p class="h4 font-weight-bold mb-0">Address</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-4" v-if="!collapsed['address']">
                  <b-col cols="12">
                    <b-form-group label="Address Line 1" :invalid-feedback="validationInvalidFeedback(errors, 'address.address_line_1')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.address_line_1')" v-model="repair.ticket.ticket_address.address_line_1" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group label="Address Line 2" :invalid-feedback="validationInvalidFeedback(errors, 'address.address_line_2')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.address_line_2')" v-model="repair.ticket.ticket_address.address_line_2" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="City" :invalid-feedback="validationInvalidFeedback(errors, 'address.city')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.city')" v-model="repair.ticket.ticket_address.city" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="County" :invalid-feedback="validationInvalidFeedback(errors, 'address.county')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.county')" v-model="repair.ticket.ticket_address.county" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-form-group label="Postcode" :invalid-feedback="validationInvalidFeedback(errors, 'address.postcode')">
                      <b-form-input :disabled="true" :state="validationState(errors, 'address.postcode')" v-model="repair.ticket.ticket_address.postcode" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col class="d-flex flex-row" cols="12" md="9" @click.prevent="toggleCollapse('image_collapse')" role="button">
                    <b-icon class="align-self-center cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['image_collapse'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                    <div class="d-flex flex-column flex-fill ml-4">
                      <p class="h4 font-weight-bold mb-0">Images</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-4" v-if="!collapsed['image_collapse']">
                  <b-col cols="12" md="12">
                    <h4>Serial Number Image</h4>
                    <b-img :src="returnTicketFileUrl('serial_number_image')" fluid block></b-img>
                  </b-col>
                  <b-col cols="12" md="12">
                    <h4>Hot Tub Image</h4>
                    <b-img :src="returnTicketFileUrl('hot_tub_image')" fluid block></b-img>
                  </b-col>
                  <b-col cols="12" md="12">
                    <h4>Problem File</h4>
                    <b-img v-if="returnTicketFileType('problem_file') == 'image'" :src="returnTicketFileUrl('problem_file')" fluid block></b-img>
                    <video class="w-100" v-if="returnTicketFileType('problem_file') == 'video'" :src="returnTicketFileUrl('problem_file')" controls></video>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col class="d-flex flex-row" cols="12" md="9" @click.prevent="toggleCollapse('complete_repair')" role="button">
                    <b-icon class="align-self-center cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['complete_repair'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                    <div class="d-flex flex-column flex-fill ml-4">
                      <p class="h4 font-weight-bold mb-0">Complete Repair</p>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="mt-4" v-if="!collapsed['complete_repair']">
                  <b-col cols="12">

                    <b-form-group label="Ticket Issue Resolved" :invalid-feedback="validationInvalidFeedback(errors.errors, 'issue_resolved')">
                      <b-form-radio-group v-model="repair.issue_resolved">
                        <b-form-radio :value="1">The ticket issue has been resolved.</b-form-radio>
                        <b-form-radio :value="0">The ticket issue has not been resolved.</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>

                    <b-form-group label="Update Ticket Status" :invalid-feedback="validationInvalidFeedback(errors.errors, 'status')" v-if="repair.issue_resolved">
                      <b-form-select :disabled="isSaving" :options="statuses" :state="validationState(errors.errors, 'status')" v-model="repair.ticket.status" />
                    </b-form-group>

                    <b-form-group label="Repair Note" :invalid-feedback="validationInvalidFeedback(errors.errors, 'repair_note')">
                      <b-form-textarea :disabled="isSaving" :state="validationState(errors.errors, 'repair_note')" v-model="note" />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="12">
                    <b-img :src="returnFileUrl('repair_file')" fluid block></b-img>
                    <b-form-group label="Repair File (Photo of the job)" :invalid-feedback="validationInvalidFeedback(errors.errors, 'repair_file')">
                        <b-form-file
                          v-model="repair_file"
                          :state="Boolean(repair_file)"
                          @input="fileChanged('repair_file')"
                          :placeholder="repair_file ? repair_file.name : 'Choose a file or drop it here...'"
                          drop-placeholder="Drop file here..."
                        ></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-4" v-if="!isLoading">
            <b-col cols="12">
              <b-card>
                <b-row>
                  <b-col cols="12">
                    <b-row>
                      <b-col cols="12" sm="7" clsass="d-flex flex-row align-items-center">
                        <div class="w-100 d-flex flex-row" @click.prevent="toggleCollapse('dispatched_messages')" role="button">
                          <b-icon class="cursor-pointer text-muted" font-scale="1.5" :icon="collapsed['dispatched_messages'] ? 'chevron-right' : 'chevron-down'"></b-icon>
                          <div class="d-flex flex-column flex-fill ml-4">
                            <p class="h4 font-weight-bold mb-0">Dispatched Messages</p>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row v-if="!collapsed['dispatched_messages']">
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-row :class="repair.dispatched_messages.length ? 'mt-4' : ''" v-if="!collapsed['dispatched_messages']">
                  <b-col cols="12" v-if="!repair.dispatched_messages.length" class="p-4">
                    <b-row>
                      <b-col class="text-center" cols="12">
                        <b-card class="py-3 text-center">
                          <p class="mb-4"><fa-icon class="display-1 text-dark" icon="times"></fa-icon></p>
                          <p class="font-weight-normal h5 mb-0 text-dark">There have been no dispatched messages to this customer.</p>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" v-if="repair.dispatched_messages.length">
                    <b-card no-body>
                      <b-row v-for="(message, messageInd) in repair.dispatched_messages" :key="messageInd">
                        <b-col cols="12">
                          <b-row v-if="messageInd > 0">
                            <b-col cols="12">
                                <div class="m-3"><hr></div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12" md="7" class="d-flex flex-row align-items-center">
                              <div class="mt-3 ml-3 mb-0 mb-md-3">
                                <h5 v-if="message.subject">{{ message.subject }}</h5>
                                <h5 v-if="!message.subject">{{ message.type }}</h5>
                                <small class="text-small text-muted" v-if="message.read_at">Read At: {{ moment(message.read_at).format('DD/MM/YYYY') }}<br></small>
                                <small class="text-muted" v-if="message.subject">{{ message.type }}</small>
                              </div>
                            </b-col>
                            <b-col cols="12" md="5" class="d-flex flex-column flex-fill align-items-start justify-content-start align-items-md-end w-100 max-width">
                              <div class="ml-3 mr-3 mt-0 mt-md-3">
                                <small class="text-right"><span class="text-muted">{{ moment(message.created_at).format('DD/MM/YYYY @ HH:MM') }}</span></small>
                              </div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12">
                                <div class="m-3"><hr></div>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col cols="12">
                                <div class="m-3" v-html="message.content">
                                </div>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col class="d-flex flex-row" cols="12" md="4" offset-md="8">
              <b-button block class="align-self-end mb-3" type="submit" variant="secondary"><b-spinner small v-if="isSaving"></b-spinner><span v-if="!isSaving">Save</span></b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import FriendlyDate from '../../components/FriendlyDate'
import validation from '../../mixins/validation'
import { mapActions, mapGetters } from 'vuex'
import momentMixin from '../../mixins/momentMixin'

export default {
  mixins: [validation, momentMixin],
  components: { FriendlyDate },
  computed: {
    ...mapGetters('repairs', ['errors', 'isLoading', 'isSaving', 'single'])
  },
  data () {
    return {
      collapsed: {
        address: true,
        complete_repair: false,
        image_collapse: true,
        notes: true,
        dispatched_messages: true,
      },

      status: null,
      statuses: [],
      note: null,
      repair_file: null,

      repair: {
        id: null,
        ticket_id: null,
        team_id: null,
        team: { id: null },
        repair_at: null,
        repair_file: null,
        duration: null,
        issue_resolved: 0,
      },
      cancelRepairClicked: false,
    }
  },
  created() {
    var self = this;
    if (this.$route.params.id) {
      this.fetch(this.$route.params.id)
    }
    this.fetchStatuses().then(response => {
      self.statuses = response.data;
    });
  },
  methods: {

    ...mapActions('repairs', ['fetch', 'complete', 'fetchStatuses']),

    toggleCollapse (name) {
      this.collapsed[name] = !this.collapsed[name]
    },

    submit () {
      let formData = new FormData();
      formData.append('issue_resolved', this.repair.issue_resolved);
      formData.append('repair_note', this.note);
      if(this.repair.issue_resolved == 1) {
        formData.append('status', this.repair.ticket.status);
      }
      
      if(Object(this.repair.repair_file).hasOwnProperty('id')) {
        formData.append('repair_file', this.repair.repair_file.id);
      }else{
        formData.append('repair_file', this.repair.repair_file);
      }

      this.complete({ 'repairId': this.$route.params.id, 'repair': formData }).then(response => {
        if([ 200, 201 ].includes(response.status)) this.$router.push({
          name: 'dash.repairs.list',
          params: {
            notifications: [{
              variant: 'success',
              title: `Repair #${response.data.id}`,
              subtitle: `Ticket Status: ${response.data.ticket.status}`,
              text: `The repair has been completed successfully.`,
              timeout: 2500
            }]
          }
        })
      })
    },

    fileChanged(fileKey) {
      this.repair[fileKey] = this[fileKey]
    },

    returnFileUrl(fileKey) {
      if(this.repair[fileKey]) {
        return this.repair[fileKey].url ?? URL.createObjectURL(this.repair[fileKey])
      }
    },

    cancelRepair() {
      if(this.cancelRepairClicked) {
        axios.post(`/repairs/cancel/${this.repair.id}`).then(response => {
          if([ 200, 201 ].includes(response.status)) this.$router.push({
            name: 'dash.repairs.list',
            params: {
              notifications: [{
                variant: 'success',
                title: `Repair #${response.data.id}`,
                text: `The repair has been cancelled successfully.`,
                timeout: 2500
              }]
            }
          })
        })
      }else{
        this.cancelRepairClicked = true
        setTimeout(() => {
          this.cancelRepairClicked = false;
        } , 3000)
      }
    },

    returnTicketFileUrl(fileKey) {
      if(this.repair.ticket[fileKey]) {
        return this.repair.ticket[fileKey].url ?? URL.createObjectURL(this.repair.ticket[fileKey])
      }
    },
    
    returnTicketFileType(fileKey) {
      if(this.repair.ticket[fileKey]) {
        return this.repair.ticket[fileKey].mimetype.split('/')[0];
      }
    }
  },
  watch: {
    single () {
      this.repair = this.single
      if(this.repair.ticket) {
        this.status = this.repair.ticket.status
      }
    }
  }
}
</script>

<style>

</style>
